import { render, staticRenderFns } from "./note-files-edit.html?vue&type=template&id=57882e00&scoped=true&"
import script from "./note-files-edit.js?vue&type=script&lang=js&"
export * from "./note-files-edit.js?vue&type=script&lang=js&"
import style0 from "./note-files-edit.css?vue&type=style&index=0&id=57882e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57882e00",
  null
  
)

export default component.exports